<template>
  <q-linear-progress
    v-if="$context.clientReloadProgress > 0"
    :value="$context.clientReloadProgress"
    :animation-speed="$context.clientReloadProgress <= 0.6 ? 3000 : 500"
    data-test-id="site-switch-progress-bar"
  />
</template>

<script>
export default {
  name: 'SiteSwitchProgressBar',
  // Ensures $context exists on component
  context: ['currentUser']
}
</script>
